export default __webpack_public_path__ + "static/media/arenPro2.ca528e58.jpg";